import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { TrashIcon } from "@radix-ui/react-icons";

export function DeleteDialog({ item, onDelete }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <TrashIcon className="h-5 w-4 cursor-pointer" />
      </AlertDialogTrigger>
      <AlertDialogContent className="dark:border-body-color dark:bg-dark">
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure to delete {item}?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the{" "}
            {item} and remove data from our database.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="dark:border-body-color dark:bg-dark">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            className="bg-red-500 hover:bg-red-700 dark:bg-red-500 dark:text-white dark:hover:bg-red-700"
            onClick={onDelete}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
